<template>
  <div class="d-flex">
    <!-- CARD BACKGROUND IMAGE FILTERS -->
    <v-card
      flat
      outlined
      class="ma-0 pa-0 mr-1"
      style="min-width: 48px"
      v-if="backBtn"
    >
      <v-card-title
        class="ma-0 pa-0 px-1 caption font-weight-normal justify-center grey lighten-4 grey--text"
        ><div class="headerClass">
          {{ $t("fabricBackgroundImageGroupControlsBackTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>

        <!-- GUMB BACK TO MAIN MENU -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          :style="
            $vuetify.breakpoint.width > 400
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
          @click="
            $store.state.storePhotoGiftOrderDesign.canvasTemplates[0].canvas.showFillBackControls = false
          "
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1">mdi-arrow-left-circle</v-icon>
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricBackgroundImageGroupControlsMenuTitle") }}
            </div></v-card-title
          >
        </v-card>

        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <!-- CARD BACKGROUND IMAGE FILTERS -->
    <v-card flat outlined class="ma-0 pa-0 mr-1" style="min-width: 48px">
      <v-card-title
        class="ma-0 pa-0 px-1 caption font-weight-normal justify-center grey lighten-4 grey--text"
        ><div class="headerClass">
          {{ $t("fabricBackgroundImageGroupControlsTitle") }}
        </div></v-card-title
      >
      <v-card-actions class="ma-0 pa-0 px-1">
        <v-spacer></v-spacer>

        <!-- GUMB BACKGROUND IMAGE FILTER -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          :style="
            $vuetify.breakpoint.width > 400
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
          @click="cBackgroundImageFilter()"
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1"
              >mdi-image-filter-vintage</v-icon
            >
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricFiltersFilter") }}
            </div></v-card-title
          >
        </v-card>

        <v-spacer></v-spacer>
        <!-- GUMB BACKGROUND BRIGHTNESS FILTER -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              :style="
                $vuetify.breakpoint.width > 400
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
              v-on="on"
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon color="accent" class="mt-1"
                  >mdi-lightbulb-on-outline</v-icon
                >
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
                ><div class="headerClass">
                  {{ $t("fabricFiltersBrightness") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card class="pa-4">
            <v-card-text class="pa-0">
              <v-slider
                v-model="template.canvas.backgroundImageBrightness"
                class="align-center"
                :max="1"
                :min="-1"
                :step="0.05"
                hide-details
                vertical
                @change="cBackgroundImageBrightness()"
              ></v-slider>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
        <!-- GUMB BACKGROUND CONTRAST FILTER -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              :style="
                $vuetify.breakpoint.width > 400
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
              v-on="on"
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon color="accent" class="mt-1">mdi-contrast</v-icon>
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
                ><div class="headerClass">
                  {{ $t("fabricFiltersContrast") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card class="pa-4">
            <v-card-text class="pa-0">
              <v-slider
                v-model="template.canvas.backgroundImageContrast"
                class="align-center"
                :max="1"
                :min="-1"
                :step="0.05"
                hide-details
                vertical
                @change="cBackgroundImageContrast()"
              ></v-slider>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
        <!-- GUMB BACKGROUND BLUR FILTER -->
        <v-menu :close-on-content-click="true">
          <template v-slot:activator="{ on }">
            <v-card
              flat
              class="ma-0 pa-0 hover-item"
              :style="
                $vuetify.breakpoint.width > 400
                  ? 'width: 48px; max-width: 48px'
                  : 'width: 38px; max-width: 38px'
              "
              v-on="on"
            >
              <v-card-actions class="justify-center ma-0 pa-0">
                <v-icon color="accent" class="mt-1">mdi-blur</v-icon>
              </v-card-actions>
              <v-card-title
                style="font-size: 10px"
                class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
                ><div class="headerClass">
                  {{ $t("fabricFiltersBlur") }}
                </div></v-card-title
              >
            </v-card>
          </template>
          <v-card class="pa-4">
            <v-card-text class="pa-0">
              <v-slider
                v-model="template.canvas.backgroundImageBlur"
                class="align-center"
                :max="1"
                :min="0"
                :step="0.05"
                hide-details
                vertical
                @change="cBackgroundImageBlur()"
              ></v-slider>
            </v-card-text>
          </v-card>
        </v-menu>
        <v-spacer></v-spacer>
        <!-- GUMB BACKGROUND FILTERS REMOVE -->
        <v-card
          flat
          class="ma-0 pa-0 hover-item"
          :style="
            $vuetify.breakpoint.width > 400
              ? 'width: 48px; max-width: 48px'
              : 'width: 38px; max-width: 38px'
          "
          @click="removeBackgroundImageFilters()"
        >
          <v-card-actions class="justify-center ma-0 pa-0">
            <v-icon color="accent" class="mt-1">mdi-filter-remove</v-icon>
          </v-card-actions>
          <v-card-title
            style="font-size: 10px"
            class="ma-0 pa-0 px-1 font-weight-normal justify-center grey--text"
            ><div class="headerClass">
              {{ $t("fabricFiltersReset") }}
            </div></v-card-title
          >
        </v-card>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {
  changeBackgroundImageFilter,
  changeBackgroundImageBlur,
  changeBackgroundImageBrightness,
  changeBackgroundImageContrast,
} from "@/mixins/modFabricJsHelper";

export default {
  name: "fabric-background-image-controls-card",
  props: {
    template: {
      type: Object,
      required: true,
    },
    backBtn: {
      type: Boolean,
      required: false,
    },
  },
  methods: {
    cBackgroundImageBlur() {
      changeBackgroundImageBlur(this.template);
    },
    cBackgroundImageFilter() {
      // če je bil prazen filter, sedaj skočimo direktno na prvega
      if (this.template.canvas.backgroundImageFilter == 0)
        this.template.canvas.backgroundImageFilter = 1;

      changeBackgroundImageFilter(this.template, true);
    },
    cBackgroundImageBrightness() {
      changeBackgroundImageBrightness(this.template);
    },
    cBackgroundImageContrast() {
      changeBackgroundImageContrast(this.template);
    },
    removeBackgroundImageFilters() {
      this.template.canvas.backgroundImage.filters = [];
      this.template.canvas.backgroundImage.applyFilters();
      this.template.canvas.requestRenderAll();

      this.template.canvas.backgroundImageFilter = 0;
      this.template.canvas.backgroundImageBrightness = 0;
      this.template.canvas.backgroundImageBlur = 0;
      this.template.canvas.filter = 0;
    },
  },
};
</script>

<style scoped>
.hover-item {
  cursor: pointer;
}
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
}
</style>